import { render } from "./Wrap.vue?vue&type=template&id=0c94fcc0&scoped=true"
import script from "./Wrap.vue?vue&type=script&lang=js"
export * from "./Wrap.vue?vue&type=script&lang=js"

import "./Wrap.vue?vue&type=style&index=0&id=0c94fcc0&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c94fcc0"]])

export default __exports__